/** Lead session token (landing pubblica): sessionStorage + header X-Lead-Session. */

export const LEAD_SESSION_HEADER = 'X-Lead-Session';
const STORAGE_KEY = 'leadlegale_lead_session';

export function saveLeadSession(leadId, token) {
  if (!leadId || !token) return;
  try {
    sessionStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ leadId: String(leadId), token: String(token) })
    );
  } catch {
    /* ignore quota / private mode */
  }
}

export function readLeadSession(leadId) {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (String(parsed?.leadId || '') !== String(leadId || '')) return null;
    return parsed?.token || null;
  } catch {
    return null;
  }
}

export function clearLeadSession() {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
}

export function buildLeadSessionHeaders(leadId, extra = {}) {
  const token = readLeadSession(leadId);
  if (!token) return { ...extra };
  return { [LEAD_SESSION_HEADER]: token, ...extra };
}

export function formatLeadSessionError(err) {
  const status = err?.response?.status;
  if (status === 401) {
    const detail = String(err?.response?.data?.detail || '').toLowerCase();
    if (detail.includes('scadut')) {
      return 'Sessione scaduta. Ricarica la pagina e invia di nuovo la richiesta.';
    }
    return 'Sessione non valida. Ricarica la pagina e invia di nuovo la richiesta.';
  }
  if (status === 403) {
    return 'Non è possibile completare l\'invio. Contattaci per assistenza.';
  }
  return null;
}
